module.exports = __webpack_public_path__ + "img/dee21bb.svg";